import { BaseOption } from '@app/shared/models';
import {
  CommercialDocumentProcessType,
  SourceType
} from '@app/pages/commercial-documents/components/commercial-document-list/enums/commercial-document-list.enum';

export const sourceTypeOptions = (
  type: CommercialDocumentProcessType
): BaseOption<SourceType>[] => {
  switch (type) {
    case CommercialDocumentProcessType.Agreement: {
      return [
        {
          name: 'CATALOG',
          value: SourceType.Catalog
        },
        {
          name: 'PR',
          value: SourceType.PurchaseRequest
        }
      ];
    }
    case CommercialDocumentProcessType.Order: {
      return [
        {
          name: 'AGREEMENT_SOURCE_TYPE',
          value: SourceType.Agreement
        },
        {
          name: 'CATALOG',
          value: SourceType.Catalog
        },
        {
          name: 'PR',
          value: SourceType.PurchaseRequest
        }
      ];
    }
    default: {
      return [];
    }
  }
};
